import { Empty } from 'antd';

import { PageTitle } from '@style/pages/page.style';

import { Table } from '@atom/table/table';
import { PaginationOffset } from '@component/pagination/pagination-offset';
import { useStoreSelector } from '@hook/store/store.hooks';
import { useMedia } from '@hook/style/use-media.hook';
import { isExist } from '@util/data/is-exist';

import { useApplicationCredentials } from './credentials.hook';
import { credentialColumns } from './credentials.options';
import { CredentialPageWrapper, SubTitle, SubTitleWrapper } from './credentials.page-style';
import { NewCredential } from './new-credential/new-credential';

export const CredentialsPage = () => {
  const { data, pagination, isLoading, onPage } = useApplicationCredentials();
  const { isTablet, isMobile } = useMedia();
  const shouldShowDeleteButton = useStoreSelector((state) => state.credentials.data.length > 1);

  return (
    <CredentialPageWrapper>
      <PageTitle>Credentials</PageTitle>
      <SubTitleWrapper>
        <SubTitle>Api Keys</SubTitle>
        <NewCredential />
      </SubTitleWrapper>
      <Table
        columns={credentialColumns(isTablet, isMobile, shouldShowDeleteButton)}
        dataSource={data}
        footer={isExist(pagination) ? () => <PaginationOffset pagination={pagination} onPage={onPage} /> : undefined}
        loading={isLoading}
        locale={{ emptyText: <Empty description='No credentials' image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
        pagination={false}
        rowKey='id'
      />
    </CredentialPageWrapper>
  );
};
